module.exports = __webpack_public_path__ + "img/ic_white_english.75611e3a.svg";